// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7GDJw","footer":"styles_footer__2mpAX","passCodeTooltip":"styles_passCodeTooltip__34ilf"};